import styled from "styled-components";

const CommunityWrapper = styled.div`
  padding: 0 16px;
`;

export default CommunityWrapper;
